import React, { Component, Fragment } from 'react'
import SimpleModalWrapped from './../common/Modal'
import TextField from './../common/TextField'
import { withStyles } from '@mui/styles'
import Tooltip from '@mui/material/Tooltip'
import { unitsList } from './unitsPortList'
import MenuItem from '@mui/material/MenuItem'
import Grid from '@mui/material/Grid'
import SingleSelect from '../common/SingleSelect'
import withTranslationWrapper from '../../HOC/HocTranslate'
import { timeZonesTypes } from './../Attributes/timezone'
// import { parentUnitsLimit, getDevices } from '../../Actions/Devices'
import { checkPrivileges } from '../../Helpers'
// import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers'
// import DateFnsUtils from '@date-io/date-fns'
import axios from 'axios'
// import SelectUser from './unitDetail/Components/changesOwnerShipe'
import { notifyError} from '../../Utils/CustomNotifcations'
import CustomDatePicker from '../common/CustomDatePicker'
import { apiFetch } from '../../Utils/apiFetch'
import instance from '../../axios'
import DeviceDataUsage from './unitDetail/Components/DeviceDataUsage'

const validateOperationalHours = value => {
  if (value === '' || value == null) {
    return null
  }
  const num = Number(value)
  if (!Number.isFinite(num) || num < 1 || num > 24) {
    return 'Min 1, Max 24 hours'
  }
  return null
}

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  button: {
    margin: theme.spacing(1)
  }
})
const category = [
  'default',
  'arrow',
  'car',
  'pickup',
  'doublecabinpickup',
  'threetonpickup',
  'van',
  
  'suv',
  'offroad',
  'minibus',
  'smallbus',
  'bus',
  'train',
  'tram',
  
  'trolleybus',
  'truck',
  'forklift',
  'tractor',
  'dumper',
  'roadroller',
  'excavator',

  'boomloader',
  'crane',
  'dumptruck',
  'tanker',
  'flatbedtruck',
  'container',
  'mixer',

  'bulldozer',
  'skidloader',
  'plane',
  'helicopter',
  'boat',
  'ship',
  'bicycle',
  
  'motorcycle',
  'scooter',
  'person',
  // 'shovel',
  'biggenerator',
  'generator',
  'animal'
]
const fuelTypes = [
  { value: 1, label: 'Gasoline' },
  { value: 2, label: 'Diesel' },
  { value: 3, label: 'Ethanol' },
  { value: 4, label: 'Hybrid' },
  { value: 5, label: 'Electric' },
  { value: 6, label: 'Biodiesel' },
  { value: 7, label: 'CNG' },
  { value: 8, label: 'LPG' },
  { value: 9, label: 'Hydrogen' }
]
const lifecycleStatuses = ['Active', 'In Maintenance', 'Suspended', 'Retired']
const transmissionTypes = ['Manual', 'Automatic', 'Semi-Automatic', 'CVT', 'Other']
let source
class addDevice extends Component {
  constructor () {
    super()
    this.state = {
      usersData: '',
      parentId: '',
      resultMessage: '',
      defaultOption: [],
      value: []
    }
    this.searchFromZoneList = this.searchFromZoneList.bind(this)
    this.searchFromList = this.searchFromList.bind(this)
    // this.checkRequiredFields = this.checkRequiredFields.bind(this)

  }
  componentWillMount () {
    apiFetch(`/api/users/list?userId=${this.props.logInUser.id}&limit=100`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        response.json().then(res => {
   if (res.status === "success") {
  let data = res.data;
  let result = data.data.map((item) => ({
    ...item,
    label: item.label || item.name,
    value: item.id,
  }));

  if (result.length === 0) {
    this.setState({
      resultMessage: "No option found",
      defaultOption: "",
    });
  } else {
    if (result.length < data?.total) {
      result.push({
        label: "Search for more items...",
        value: "__more__",
        isDisabled: true,
      });
    }

    this.setState({
      resultMessage: "",
      defaultOption: result,
    });
  }
}

          else if(res?.statusCode === '440'){
            window.location.replace('/login')
          }
           else if(res.statusCode){
            var err = res?.message.split(':')
            err[1] =err[1].replace(')', "")
            this.props.dispatch(
              notifyError(this.props.translate(err[1]))
            )
          }
         
        })
      }
      else{
        throw response
      }
    }).catch(e => {})
  }
  // checkRequiredFields () {
  //   if (this.state.value) {
  //     this.setState({
  //       isVisableAddBtn: true
  //     })
  //   } else {
  //     this.setState({
  //       isVisableAddBtn: false
  //     })
  //   }
  // }
  onChange = (name, value) => {
    this.setState({ value: value })
  }
  searchList = async inputValue => {
    if (!inputValue) {
      return []
    }

    let response = await apiFetch(
      `/api/users/list?userId=${this.props.logInUser.id}&all=true&search=${inputValue}&limit=100`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
    let json = await response.json()
    let result =
      (await json.data) && (json.data.data) &&
      json.data.data.map(item => ({
        ...item,
        label: item.label || item.name,
        value: item.id
      }))
    if (result.length === 0) {
      this.setState({
        resultMessage: 'No option found'
      })
    } else {
      this.setState({
        resultMessage: ''
      })
    }

    if (json.hasNext) {
      result.push({
        value: null,
        isDisabled: true,
        label: 'Search for more.'
      })
    }
    return result
  }
  async searchFromList (inputValue) {
    if (!inputValue) {
      return []
    }

    const result = []

       return await instance({
         method: 'GET',
         url: `/api/devices/models?search=${inputValue}`,
         headers: {
           Accept: 'application/json',
           'Content-Type': 'application/json'
           }

        }).then(res => {
          let response = res.data
          if(response.status==='success'){
            if(response&&response.data.data&&response.data.data){
              return response.data.data.map(item => {
                return {
                  id: item.name,
                  name: item.name,
                  key: item.name,
                  port: item.port,
                  protocol: item.protocol,
                  label: item.name,
                  value: item.name
                }
              })
            }
          }
          else if(response?.statusCode === '440'){
            window.location.replace('/login')
          } 
          else if(response?.statusCode){
            var err = response?.message.split(':')
            err[1] =err[1].replace(')', "")
            this.props.dispatch(
              notifyError(this.props.translate(err[1]))
            )
          }
    })
  }

  async searchFromZoneList (inputValue) {
    if (!inputValue) {
      return []
    }

    let result = timeZonesTypes.filter(i =>
      i.key.toLowerCase().includes(inputValue.toLowerCase())
    )
    return await result.map(item => {
      return { id: item.key, key: item.key, label: item.key, value: item.key }
    })
  }

  render () {
    let { value, defaultOption } = this.state
    const { classes, group } = this.props
    const operationalHoursError = validateOperationalHours(
      this.props.form && this.props.form.operationalHours
    )
    const defaultOptions = []
    unitsList.map((item, i) => {
      if (i <= 9) {
        defaultOptions.push({
          id: item.device,
          name: item.device,
          key: item.device,
          port: item.port,
          protocol: item.protocol,
          label: item.device,
          value: item.port
        })
      }
      return null
    })
    if (defaultOptions && defaultOptions.length < unitsList.length && unitsList) {
    defaultOptions.push({
      id: '',
      name: 'Search for more items...',
      key: '',
      port: '',
      label: 'Search for more items...',
      value: '',
      isDisabled: true
    });
  }
    const defaultZones = []
    timeZonesTypes.map((item, i) => {
      // if (i <= 9) {
        defaultZones.push({
          id: item.key,
          key: item.key,
          label: item.key,
          value: item.key
        })
      // }
    })
  
    return (
      <Fragment>
        <SimpleModalWrapped
          {...this.state}
          {...this.props}
          visable
          isButtonVisable
          title='Required'
          isNotShowAttributesBtn
          formSubmit={this.props.formSubmit}
          addAttributes={this.addAttributes}
          modalControle={this.props.modalControle}
          btnclosetext={this.props.translate('sharedBack')}
          buttonText={this.props.buttonText}
          isVisableBtn={this.props.isVisableDeviceBtn}
          notVisableBackbtn={this.props.notVisableBackbtn}
          showPortList={this.props.showPortList}
          showPort={this.props.showPort}
          content={
            <Fragment>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <h4 style={{ margin: '5px 0 0' }}>Vehicle Details</h4>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='name'
                    label={this.props.translate('sharedName')}
                    type='text'
                    placeholder=''
                    value={this.props.form.name}
                    onChange={this.props.handleChange('name')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='vehicleLicensePlate'
                    label='License Plate'
                    value={this.props.form.vehicleLicensePlate || ''}
                    onChange={this.props.handleChange('vehicleLicensePlate')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='vin'
                    label='VIN / Chassis'
                    value={this.props.form.vin || ''}
                    onChange={this.props.handleChange('vin')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='vehicleMake'
                    label='Make'
                    value={this.props.form.vehicleMake || ''}
                    onChange={this.props.handleChange('vehicleMake')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='vehicleModel'
                    label='Vehicle Model'
                    value={this.props.form.vehicleModel || ''}
                    onChange={this.props.handleChange('vehicleModel')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='vehicleYear'
                    label='Year'
                    type='number'
                    value={this.props.form.vehicleYear || ''}
                    onChange={this.props.handleChange('vehicleYear')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <h4 style={{ margin: '10px 0 0' }}>Tracker Details</h4>
                </Grid>
                {this.props.creatingUnit && (
                  <Grid item md={3} sm={6} xs={12}>
                    <SingleSelect
                      array={[]}
                      async
                      selectName='parentId'
                      defaultOptions={defaultOption}
                      loadOptions={this.searchList}
                      label={this.props.translate('selectParentUsers')}
                      value={
                        this.props.form.parentId
                          ? {
                              key: this.props.form.parentId,
                              id: this.props.form.parentId,
                              label: this.props.labelSelected
                            }
                          : {
                              key: 'Select Parent Account',
                              id: 'Select Parent Account',
                              label: 'Select Parent Account'
                            }
                      }
                      handleChange={this.props.handleChangeParent}
                      canAssign={true}
                      placeholder="parentUser"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                         />
                    </Grid>
                )}
                {((this.props.editOption) && (this.props.logInUser.attributes&&this.props.logInUser.attributes.viewModel)) ? 
                     checkPrivileges('deviceModel') ? ( 
                      <Grid item md={3} sm={6} xs={12} style={{position: 'relative', zIndex: 9}}>
                        <SingleSelect
                          array={[]}
                          async
                          selectName='model'
                          isClearable
                          defaultOptions={defaultOptions}
                          loadOptions={this.searchFromList}
                          label={this.props.translate('deviceModel')}
                          value={
                            typeof this.props.form.model === 'object'
                              ? this.props.form.model
                              : this.props.form.model
                              ? {
                                  id: this.props.form.model,
                                  key: this.props.form.model,
                                  label: this.props.form.model,
                                  value: this.props.form.model
                                }
                              : {
                                  key: 'Select Model',
                                  id: 'Select Model',
                                  label: 'Select Model'
                                }
                          }
                          handleChange={this.props.port_handleChange}
                          canAssign
                          editUnitCase={this.props.editOption}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      </Grid>
                      ) : null
                : (this.props.logInUser.userType ===-1 || this.props.addOption) ?
                 (<Grid item md={3} sm={6} xs={12} style={{position: 'relative', zIndex: 9}}>
                      <SingleSelect
                        array={[]}
                        async
                        selectName='model'
                        isClearable
                        defaultOptions={defaultOptions}
                        loadOptions={this.searchFromList}
                        label={this.props.translate('deviceModel')}
                        value={
                          this.props.form.model
                            ? {
                                key: this.props.form.model,
                                id: this.props.form.model,
                                label: this.props.form.model
                              }
                            : {
                                key: 'Select Model',
                                id: 'Select Model',
                                label: 'Select Model'
                              }
                        }
                        handleChange={this.props.port_handleChange}
                        canAssign
                        editUnitCase={this.props.editOption}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                  </Grid>):null
                 } 
                {(this.props.editOption && this.props.logInUser.attributes&&this.props.logInUser.attributes.viewIMEI) ? 
                   (<Grid item md={3} sm={6} xs={12}>
                  {this.props.form.model !== 'FX Tracker' ? (
                    <TextField
                      id='uniqueId'
                      error={this.props.duplicateIdentifier}
                      label={this.props.translate('deviceIdentifier')}
                      InputProps={ this.props.editOption ? {readOnly: !checkPrivileges('deviceImei')}: ''  }
                      // disabled={
                      //   this.props.editOption &&
                      //   this.props.logInUser &&
                      //   this.props.logInUser.userType !== -1
                      // }
                      type='text'
                      placeholder=''
                      value={this.props.form.uniqueId}
                      onChange={this.props.handleChange('uniqueId')}
                      variant='outlined'
                      margin='dense'
                      fullWidth
                      required
                    />
                  ) : (
                    <Tooltip title={this.props.translate('autoGeneratedId')}>
                      <TextField
                        id='uniqueId'
                        label={this.props.translate('deviceIdentifier')}
                        type='text'
                        placeholder=''
                        value={this.props.form.uniqueId}
                        variant='outlined'
                        margin='dense'
                        fullWidth
                        required
                      />
                    </Tooltip>
                  )}
                </Grid>)
                 :(this.props.logInUser.userType ===-1 || this.props.addOption) ? 
                 (<Grid item md={3} sm={6} xs={12}>
                  {this.props.form.model !== 'FX Tracker' ? (
                    <TextField
                      id='uniqueId'
                      error={this.props.duplicateIdentifier}
                      label={this.props.translate('deviceIdentifier')}
                      InputProps={ this.props.editOption ? {readOnly: !checkPrivileges('deviceImei')}: ''  }
                      // disabled={
                      //   this.props.editOption &&
                      //   this.props.logInUser &&
                      //   this.props.logInUser.userType !== -1
                      // }
                      type='text'
                      placeholder=''
                      value={this.props.form.uniqueId}
                      onChange={this.props.handleChange('uniqueId')}
                      variant='outlined'
                      margin='dense'
                      fullWidth
                      required
                    />
                  ) : (
                    <Tooltip title={this.props.translate('autoGeneratedId')}>
                      <TextField
                        id='uniqueId'
                        label={this.props.translate('deviceIdentifier')}
                        type='text'
                        placeholder=''
                        value={this.props.form.uniqueId}
                        variant='outlined'
                        margin='dense'
                        fullWidth
                        required
                      />
                    </Tooltip>
                  )}
                </Grid>)
                 :null}

                <Grid item md={3} sm={6} xs={12}>
                  <CustomDatePicker
                    format='dd/MM/yyyy'
                    error={false}
                    label={this.props.translate('installDate')}
                    fullWidth
                    value={this.props.form.attributes?.installDate || null}
                    onChange={date =>
                      this.props.handleChangeLicenseExpDate('installDate', date)
                    }
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <CustomDatePicker
                    format='dd/MM/yyyy'
                    error={false}
                    label={this.props.translate('expireDate')}
                    fullWidth
                    value={this.props.form.expirationTime || null}
                    onChange={date =>
                      this.props.handleChangeLicenseExpDate(
                        'expirationTime',
                        date
                      )
                    }
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='phone'
                    label='Phone/ICCID/IMSI'
                    type='text'
                    placeholder=''
                    value={this.props.form.phone}
                    onChange={this.props.handleChange('phone')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='onlineTime'
                    label='Online Time'
                    type='number'
                    value={this.props.form.attributes?.onlineTime || ''}
                    onChange={e => this.props.changeAttribute2('onlineTime', e)}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
             {this.props.addOption && (
    <Grid item xs={12} sm={12} md={3}>
      <div
        style={{
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          fontSize: 14,
          background: '#ebebeb',
          color: 'black',
          padding: '6px 10px',
          marginTop: 0,
          borderRadius: 4,
        }}
      >
        <div>
          {this.props.translate(
            'toConfigureYourDeviceManuallyUseConnectionParameters'
          )}
        </div>

        <div style={{ marginTop:1}}>
          <label
            style={{
              width: '40%',
              display: 'inline-block',
              fontWeight: 500,
            }}
          >
            {this.props.translate('serverIp')}:
          </label>
          <span>{this.props.serverIp}</span>
        </div>

        <div style={{ marginTop:1}}>
          <label
            style={{
              width: '40%',
              display: 'inline-block',
              fontWeight: 500,
            }}
          >
            {this.props.translate('Port')}:
          </label>
          <span>{this.props.form.device}</span>
        </div>
      </div>
    </Grid>
)}
              </Grid>
              <h4>Tracker Specifications</h4>
              <Grid container spacing={2}>
                {/* <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='groupId'
                    select
                    label={this.props.translate('groupDialog')}
                    value={this.props.form.groupId}
                    onChange={this.props.handleChange('groupId')}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu
                      }
                    }}
                    margin='dense'
                    fullWidth
                  >
                    <MenuItem value={0}>
                      <em>{this.props.translate('none')}</em>
                    </MenuItem>
                    {group &&
                      group.data &&
                      group.data.map(option => (
                        <MenuItem key={option.name} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid> */}
                {/* {(this.props.addOption || (this.props.logInUser.userType !== 4 && this.props.logInUser.attributes.hideModal !== true)) &&
                  <Grid item md={3} sm={6} xs={12}>
                    <TextField
                      id='model'
                      label={this.props.translate('model')}
                      type='text'
                      placeholder=''
                      value={this.props.form.model}
                      onChange={this.props.handleChange('model')}
                      variant='outlined'
                      margin='dense'
                      fullWidth
                    />
                  </Grid>} */}
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='contact'
                    label={this.props.translate('deviceContact')}
                    placeholder=''
                    value={this.props.form.contact}
                    onChange={this.props.handleChange('contact')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='category'
                    select
                    label={this.props.translate('deviceCategory')}
                    value={this.props.form.category}
                    onChange={this.props.handleChange('category')}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu
                      }
                    }}
                    margin='dense'
                    fullWidth
                  >
                    <MenuItem value={0}>
                      <em>{this.props.translate('none')}</em>
                    </MenuItem>
                    {this.props.categories?.map(option => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {/* <Grid item md={3} sm={6} xs={12}>
                  <Checkbox
                    checked={this.props.form.disabled}
                    onChange={this.props.handleChange('disabled')}
                    value='disabled'
                    color='primary'
                    label={this.props.translate('sharedDisabled')}
                  />
                </Grid> */}
              </Grid>
              {/* <h4 style={{ margin: '10px 0' }}>
                {this.props.translate('sharedAttributes')}
              </h4> */}
              <Grid container spacing={2}>
                <Grid item sm={3} xs={12}>
                  <TextField
                    id='attributeDevicePassword'
                    label={this.props.translate('attributeDevicePassword')}
                    placeholder=''
                    value={
                      (this.props.form.attributes &&
                        this.props.form.attributes.devicePassword) ||
                      ''
                    }
                    onChange={e =>
                      this.props.changeAttribute2('devicePassword', e)
                    }
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                {[1, 2, 3, 4, 5].map(index => (
                  <Grid item sm={3} xs={12} key={`tag_${index}`}>
                    <TextField
                      id={`tag_${index}`}
                      label={`Tag ${index}`}
                      value={this.props.form.attributes?.[`tag_${index}`] || ''}
                      onChange={e =>
                        this.props.changeAttribute2(`tag_${index}`, e)
                      }
                      variant='outlined'
                      margin='dense'
                      fullWidth
                    />
                  </Grid>
                ))}
                <Grid item sm={3} xs={12} style={{position: 'relative', zIndex: 0}}>
                  <SingleSelect
                    array={[]}
                    async
                    selectName='decoder.timezone'
                    isClearable={false}
                    defaultOptions={defaultZones}
                    loadOptions={this.searchFromZoneList}
                    label={this.props.translate('sharedTimezone')}
                    value={
                      this.props.form.attributes &&
                      this.props.form.attributes['decoder.timezone']
                        ? {
                            key:
                              this.props.form.attributes['decoder.timezone'] ||
                              '',
                            id:
                              this.props.form.attributes['decoder.timezone'] ||
                              '',
                            label:
                              this.props.form.attributes['decoder.timezone'] ||
                              ''
                          }
                        : {
                          label:"Timezone"
                        }
                    }
                    handleChange={this.props.timezone_handleChange}
                    canAssign
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </Grid>
                <Grid item sm={3} xs={12}>
   <TextField
  type="number"
  value={this.props.form.attributes?.speedLimit ?? 0}
  inputProps={{ min: 0 }}
  onChange={e => {
    let rawValue = Number(e.target.value);

    if (rawValue < 0) {
      rawValue = 0;
      e.target.value = 0;
    }

    this.props.changeAttribute2("speedLimit", e);
  }}
  label={this.props.translate("attributeSpeedLimit") + " (Km/h)"}
  variant="outlined"
  margin="dense"
  fullWidth
/>

                </Grid>
                {/* {!this.props.addOption &&
                  this.props.logInUser.userType !== 4 &&
                  this.props.logInUser.attributes.hideModal !== true && (
                    <Grid item sm={3} xs={12}>
                      <p
                        style={{
                          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                          fontSize: '16',
                          background: '#ebebeb',
                          color: 'black',
                          padding: '12px 10px',
                          marginTop: 0
                        }}
                      >
                        <span style={{ display: 'block' }}>
                          <label
                            style={{ width: '40%', display: 'inline-block' }}
                          >
                            {this.props.translate('Port')}:
                          </label>
                          <span>
                            {this.props.form.device
                              ? this.props.form.device
                              : this.props.form.attributes
                              ? this.props.form.attributes.port
                              : 'null'}
                          </span>
                        </span>
                        <span style={{ display: 'block' }}>
                          <label
                            style={{ width: '40%', display: 'inline-block' }}
                          >
                            {this.props.translate('sharedName')}:
                          </label>
                          <span>{this.props.form.model || 'null'}</span>
                        </span>
                      </p>
                    </Grid>
                  )} */}
              </Grid>
              {this.props.editOption &&
                this.props.logInUser &&
                this.props.logInUser.userType === -1 &&
                this.props.form &&
                this.props.form.id && (
                  <DeviceDataUsage
                    deviceId={this.props.form.id}
                    logInUser={this.props.logInUser}
                    ServerSetting={this.props.ServerSetting}
                    dispatch={this.props.dispatch}
                  />
                )}
              <h4 style={{ margin: '18px 0 10px' }}>Vehicle Specifications</h4>
              <Grid container spacing={2}>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='operationalHours'
                    label='Operational Hours'
                    type='number'
                    inputProps={{ min: 1, max: 24, step: 1 }}
                    value={this.props.form.operationalHours || ''}
                    onChange={this.props.handleChange('operationalHours')}
                    error={!!operationalHoursError}
                    helperText={operationalHoursError || 'Min 1, Max 24 hours'}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='registrationNumber'
                    label='Registration Number'
                    value={this.props.form.registrationNumber || ''}
                    onChange={this.props.handleChange('registrationNumber')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='lifecycleStatus'
                    select
                    label='Lifecycle Status'
                    value={this.props.form.lifecycleStatus || ''}
                    onChange={this.props.handleChange('lifecycleStatus')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  >
                    <MenuItem value=''><em>None</em></MenuItem>
                    {lifecycleStatuses.map(option => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='fuelType'
                    select
                    label='Fuel Type'
                    value={this.props.form.fuelType || ''}
                    onChange={this.props.handleChange('fuelType')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  >
                    <MenuItem value=''><em>None</em></MenuItem>
                    {fuelTypes.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {[
                  ['fuelEfficiency', 'Average Fuel Efficiency', 'text'],
                  ['totalAvailablekm', 'Standard Daily Mileage', 'text'],
                  ['capacity', 'Tank Capacity', 'text'],
                  ['color', 'Color', 'text'],
                  ['chassisNumber', 'Chassis Number', 'text'],
                  ['variant', 'Variant', 'text'],
                  ['wheels', 'Wheels', 'text'],
                  ['country', 'Country', 'text']
                ].map(([name, label, type]) => (
                  <Grid item md={3} sm={6} xs={12} key={name}>
                    <TextField
                      id={name}
                      label={label}
                      type={type}
                      value={this.props.form[name] || ''}
                      onChange={this.props.handleChange(name)}
                      variant='outlined'
                      margin='dense'
                      fullWidth
                    />
                  </Grid>
                ))}
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='transmissionType'
                    select
                    label='Transmission Type'
                    value={this.props.form.transmissionType || ''}
                    onChange={this.props.handleChange('transmissionType')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  >
                    <MenuItem value=''><em>None</em></MenuItem>
                    {transmissionTypes.map(option => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              <br />
            </Fragment>
          }
        />
      </Fragment>
    )
  }
}

const AddDevice = withStyles(styles)
export default AddDevice(withTranslationWrapper(addDevice))
